@if (product$ | async; as product) {
  <div class="container">
    @for (videoLink of product?.videoLinks; track videoLink) {
      <div class="video" style="padding-top: 4px;">
        <iframe width="560" height="515" [src]="videoLink | safe: 'resourceUrl'" frameborder="0" allowfullscreen></iframe>
      </div>
    }
  </div>
}
